const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: (a, b) => a?.email?.localeCompare(b?.email),
    },
    {
        title: 'Account',
        dataIndex: 'account',
        sorter: (a, b) => a?.account?.localeCompare(b?.account),
    },
    {
        title: 'Mobile No',
        dataIndex: 'mobileNo',
        sorter: (a, b) => a?.mobileNo?.localeCompare(b?.mobileNo),
    },
    {
        title: 'Plan Name',
        dataIndex: 'planName',
        sorter: (a, b) => a?.planName?.localeCompare(b?.planName),
    },
    {
        title: 'Referral Code',
        dataIndex: 'referralCode',
        sorter: (a, b) => a?.referralCode?.localeCompare(b?.referralCode),
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        sorter: (a, b) => a?.affiliateCode?.localeCompare(b?.affiliateCode),
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    },
];

export default columns;